/**
 * Adapter Provider Component
 * Provides adapters to the entire application via React Context
 */

import { useMemo, type ReactNode } from 'react'
import { AdapterContext } from './AdapterContext'
import type { ChatAdapters } from './types'
import { createAdapters, type EmbeddedAdapterConfig } from './factory'

export interface AdapterProviderProps {
  children: ReactNode
  adapters?: ChatAdapters
  embeddedConfig?: EmbeddedAdapterConfig
  domain?: string
}

export const AdapterProvider = ({ children, adapters, embeddedConfig, domain }: AdapterProviderProps) => {
  const contextValue = useMemo(() => {
    return adapters || createAdapters(embeddedConfig, domain)
  }, [adapters, embeddedConfig, domain])

  return (
    <AdapterContext.Provider value={contextValue}>
      {children}
    </AdapterContext.Provider>
  )
}
